// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableBody__tableRow {
  height: 4rem;
  border-bottom: 1px solid #f2f2f2;
}

.tableBody__rowExpanded {
  border-bottom: none;
}

.tableBody__subRow {
  border-bottom: 1px solid #f2f2f2;

  td {
    padding-bottom: 1rem;
  }
}

.tableBody__tableData {
  background-color: #ffffff;
  height: 5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/TableBody/tableBody.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;;EAEhC;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".tableRow {\n  height: 4rem;\n  border-bottom: 1px solid #f2f2f2;\n}\n\n.rowExpanded {\n  border-bottom: none;\n}\n\n.subRow {\n  border-bottom: 1px solid #f2f2f2;\n\n  td {\n    padding-bottom: 1rem;\n  }\n}\n\n.tableData {\n  background-color: #ffffff;\n  height: 5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export var tableRow = `tableBody__tableRow`;
export var rowExpanded = `tableBody__rowExpanded`;
export var subRow = `tableBody__subRow`;
export var tableData = `tableBody__tableData`;
export default ___CSS_LOADER_EXPORT___;
